<template>
  <div class="flex flex-row flex-wrap">
    <Field name="unifiedNumber" v-slot="{ field, errors }">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('uid')"
        :maxLength="10"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        :isDisabled="!!props.values.employeeName"
        mask="numberOnly"
      />
    </Field>

    <Field name="employeeName" v-slot="{ field, errors }">
      <SimpleTextInput
        :field="field"
        :errors="errors"
        :label="$t('ApplicantName')"
        :maxLength="10"
        direction="flex-col"
        class="lg:w-1/2 flex-col px-2 w-full"
        :is-required="false"
        :is-disabled="disabledFiled"
      />
    </Field>

    <Field name="expiryFrom" v-slot="{ field, errors, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errors"
        :label="$t('expirystartDate')"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-change="(date) => handleChange(date)"
        :disabled="disabledFiled"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field name="expiryTo" v-slot="{ field, errors, handleChange }">
      <SimpleDatepicker
        :field="field"
        :errors="errors"
        :label="$t('expiryendDate')"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-change="(date) => handleChange(date)"
        :disabled="disabledFiled"
        :serverDateFormat="'yyyy/MM/dd'"
      >
      </SimpleDatepicker>
    </Field>

    <Field name="nationalityId" v-slot="{ field, errors, handleChange }">
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('nationality')"
        :options="countries"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
        :disabled="disabledFiled"
      ></SimpleDropdown>
    </Field>
    <Field name="serviceStatusId" v-slot="{ field, errors, handleChange }">
      <SimpleDropdown
        :field="field"
        :errors="errors"
        :label="$t('fileValidityNote')"
        :options="serviceStatusList"
        :is-required="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        @on-selection="(item) => handleChange(+item.id)"
      ></SimpleDropdown>
    </Field>
  </div>
</template>
<script setup>
import { defineProps,computed } from 'vue'
import { Field } from 'vee-validate'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import lookups from '@/assets/json/clientLookups.json'

const props = defineProps({
  values: Object,
  countries: Array,
  modules: Array,
  serviceStatus: Array,
  pageType: {
    type: String,
    default: 'mainPage'
  }
})

const serviceStatusList = computed(() => {
  const { visaServiceStatus } = lookups
  const visaList = [
    visaServiceStatus.visaActive,
    visaServiceStatus.visaNearlyExpired,
    visaServiceStatus.visaExpired,
    visaServiceStatus.visaUsed
  ]

  return props.serviceStatus.filter((i) => {
    return visaList.includes(i.id)
  })
})

const disabledFiled = computed(() => {
  return !!props.values.unifiedNumber
})
</script>
<style scoped lang="scss"></style>
